export {default as GirlsIcon} from './Girls'
export {default as BoysIcon} from './Boys'